import React from "react";
import styled, {keyframes} from "styled-components";
import {borderColour} from "../../style/styleConsts";

/* Adapted from http://tobiasahlin.com/spinkit/ */

const kf = keyframes`
    0%, 40%, 100% {
        transform: scaleY(0.4);
    } 20% {
       transform: scaleY(1.0);
    }
`;

const Spinner = styled.div`
    width: 30px;
    height: 20px;
    text-align: center;
    font-size: 10px;
`;

const Rectangle = styled.div`
    background-color: ${borderColour};
    height: 100%;
    width: 6px;
    display: inline-block;
    margin: 0 3px 0 0;
    animation: ${kf} 1.2s infinite ease-in-out;
    animation-delay: ${props => props.delay};
`;

const Centerer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
`;

export default function Loader() {
    return (
        <Spinner className="t-loading loader">
            <Rectangle />
            <Rectangle delay="-1.1s" />
            <Rectangle delay="-1.0s" />
        </Spinner>
    );
}

export function CentredLoader() {
    return <Centerer><Loader /></Centerer>
}
